import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { FontLineHeightNormal, Spacing4 } from 'autogen/design-tokens/tokens';
import type { ProductTabBlock } from 'autogen/swagger/all';
import { verticalEllipsis } from 'modules/helpers/mixins';

// #region Styles
const Wrapper = styled.div<{ $collapsed: boolean; $previewLines?: number }>`
    ${({ $collapsed, $previewLines }) =>
        $collapsed &&
        $previewLines &&
        css`
            ${verticalEllipsis($previewLines)}
            height: ${$previewLines * FontLineHeightNormal}rem;
        `}
    margin-bottom: ${Spacing4};
`;
// #endregion Styles

type ContentProps = {
    content: ProductTabBlock['content'];
    collapsed: boolean;
    previewLines?: number;
};

const TabContent = forwardRef<HTMLDivElement, ContentProps>(({ content, collapsed, previewLines }, ref) => (
    <Wrapper
        ref={ref}
        dangerouslySetInnerHTML={{ __html: content }}
        $collapsed={collapsed}
        $previewLines={previewLines}
    />
));

export default TabContent;
